var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_19577)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14.1558C28 21.8877 21.732 28.1558 14 28.1558C6.26801 28.1558 0 21.8877 0 14.1558C0 6.42377 6.26801 0.155762 14 0.155762C21.732 0.155762 28 6.42377 28 14.1558ZM18.3902 16.7851C17.5857 17.2985 16.7113 17.6625 15.8038 17.8725L18.2917 20.3974C18.8016 20.9117 18.8016 21.7508 18.2917 22.2679C17.7818 22.785 16.9571 22.785 16.4471 22.2679L13.9997 19.786L11.5522 22.2679C11.2963 22.5256 10.9641 22.6553 10.629 22.6553C10.2967 22.6553 9.96353 22.5256 9.70765 22.2679C9.19772 21.7508 9.19772 20.9145 9.70765 20.3974L12.1956 17.8725C11.2881 17.6625 10.4136 17.2975 9.60916 16.7851C9.00075 16.3949 8.81666 15.5773 9.20049 14.9593C9.58523 14.3396 10.3897 14.1529 11.0009 14.5421C12.8252 15.7042 15.1742 15.707 16.9985 14.5421C17.6106 14.1529 18.4151 14.3396 18.7989 14.9593C19.1836 15.5801 18.9995 16.3959 18.3902 16.7851ZM15.8461 9.67346C15.8461 8.64111 15.0195 7.80291 14.0015 7.80291C12.9863 7.80291 12.157 8.64111 12.157 9.67346C12.157 10.7039 12.9863 11.5421 14.0015 11.5421C15.0195 11.5421 15.8461 10.7039 15.8461 9.67346ZM18.4556 9.67439C18.4556 12.1629 16.4573 14.1884 14.0015 14.1884C11.5458 14.1884 9.54749 12.1638 9.54749 9.67252C9.54749 7.18126 11.5458 5.15576 14.0015 5.15576C16.4582 5.15576 18.4556 7.18126 18.4556 9.67439Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_19577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.155762)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.8247ebebae503b9b5e1f348576e2b246.svg";
export { ForwardRef as ReactComponent };